import eventParticipantService from "@/api/eventModule/eventParticipantServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      eventParticipantService
        .loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST_EVENT_PARTICIPANTS", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNew({ commit }, data) {
    return eventParticipantService
      .insertNew(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEdit({ commit }, data) {
    commit("PREPARE_TO_EDIT_EVENT_PARTICIPANT", data);
  },
  edit({ commit }, data) {
    return eventParticipantService
      .edit(data)
      .then((result) => result)
      .catch((error) => error);
  },
  reset({ commit }) {
    commit("RESET_EVENT_PARTICIPANT");
  },
  delete({ commit }, id) {
    return eventParticipantService
      .delete(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
